module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page01"
    }
  }), _vm._v("Two For One Deal")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("I")]), _vm._v("t was a wedding present that the future bride and groom would never forget. During their engagement party in Tirana, Albania, the teenage lovebirds were surprised by more than just a toaster; the groom’s father and the bride’s mother fell in love and eloped. The future in-laws became wanted outlaws when they called their respective spouses asking for a divorce, during their honeymoon in Greece. The teenagers, who finally did get married, are concerned because if the couple has a child, the new groom could eventually wind up becoming his own grandfather."), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent300"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L05_r1.jpg"
    }
  }), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent300"
  }, [_c('strong', [_vm._v("STUDY FINDS SEX, PREGNANCY LINK.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent300"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L06_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox"
  }, [_c('p', {
    staticClass: "nonindent100"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—"), _c('em', [_vm._v("Cornell Daily Sun,")]), _vm._v(" December 7, 1995")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e81280","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c01_r1.vue
// module id = 75
// module chunks = 0